import React from "react";
import { createFromIconfontCN } from "@ant-design/icons";

export const IMG_MAX_W = 200;
export const IMG_MAX_H = 200;
export const VID_MAX_W = 240;
export const VID_MAX_H = window.innerHeight * 0.3;

// 消息行高度缓存（用于撤回动画，key = idClient）
export const msgRowHeights = new Map();

// 图片/视频尺寸缓存（key = idClient，持久化跨导航）
export const mediaDimCache = new Map();

export function clampDims(w, h, maxW, maxH) {
  if (!w || !h || w <= 0 || h <= 0) return null;
  const ratio = w / h;
  let cw = w, ch = h;
  if (maxW && cw > maxW) { cw = maxW; ch = cw / ratio; }
  if (maxH && ch > maxH) { ch = maxH; cw = ch * ratio; }
  return { w: Math.round(cw), h: Math.round(ch) };
}

export function formatMsgTime(timestamp) {
  if (!timestamp) return "";
  const d = new Date(timestamp);
  const now = new Date();
  const pad = (n) => String(n).padStart(2, "0");
  const hm = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  const isToday =
    d.getDate() === now.getDate() &&
    d.getMonth() === now.getMonth() &&
    d.getFullYear() === now.getFullYear();
  if (isToday) return hm;
  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);
  const isYesterday =
    d.getDate() === yesterday.getDate() &&
    d.getMonth() === yesterday.getMonth() &&
    d.getFullYear() === yesterday.getFullYear();
  if (isYesterday) return `昨天 ${hm}`;
  return `${d.getMonth() + 1}月${d.getDate()}日 ${hm}`;
}

/**
 * 根据消息对象返回适合在回复预览中展示的文本标签
 * 覆盖所有已知消息类型（文本/图片/视频/语音/文件/地理位置/自定义各 subType）
 */
export function getMsgReplyLabel(msg) {
  if (!msg) return '[消息]';
  const { type, body, subType } = msg;
  if (type === 'image')    return '[图片消息]';
  if (type === 'video')    return '[视频消息]';
  if (type === 'audio')    return '[语音消息]';
  if (type === 'file')     return '[文件消息]';
  if (type === 'location') return '[地理位置]';
  if (type === 'tip')      return '[提示消息]';
  if (type === 'notification') return '[通知消息]';
  if (type === 'custom') {
    const sub = subType ?? msg?.attach?.subType;
    switch (sub) {
      case 1: return '[活动消息]';
      case 2: return '[攻略消息]';
      case 3: return '[交易消息]';
      case 4: return '[攻略消息]';
      case 5: return '[活动消息]';
      case 6: return '[红包通知]';
      case 7: return '[红包消息]';
      case 8: return '[红包通知]';
      case 9: return '[公告消息]';
      default: return '[自定义消息]';
    }
  }
  // 文本消息直接返回内容，截断超长部分
  if (body) return body.length > 30 ? body.slice(0, 30) + '…' : body;
  return '[消息]';
}

export const CommonIcon = createFromIconfontCN({
  scriptUrl: [
    "//yx-web-nosdn.netease.im/sdk-release/yunxun-imweb-iconfont.js",
    "//at.alicdn.com/t/c/font_3429868_blvaz7v7n6p.js",
  ],
});

export function UploadProgress({ progress }) {
  const r = 18, c = 2 * Math.PI * r;
  const offset = c - (progress / 100) * c;
  return (
    <div style={{
      position: "absolute", inset: 0,
      display: "flex", alignItems: "center", justifyContent: "center",
      background: "rgba(0,0,0,0.25)",
    }}>
      <svg width="48" height="48" viewBox="0 0 48 48">
        <circle cx="24" cy="24" r={r} fill="none" stroke="rgba(255,255,255,0.35)" strokeWidth="3" />
        <circle
          cx="24" cy="24" r={r}
          fill="none" stroke="white" strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={offset}
          transform="rotate(-90 24 24)"
          style={{ transition: "stroke-dashoffset 0.2s" }}
        />
        <text x="24" y="28" textAnchor="middle" fill="white" fontSize="11" fontWeight="bold">
          {progress}%
        </text>
      </svg>
    </div>
  );
}
